import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { db } from '../config/firebase';
import { collection, getDocs } from 'firebase/firestore';

const TakeLab = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [lab, setLab] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLabAvailable, setIsLabAvailable] = useState(true);

  useEffect(() => {
    const loadLabData = async () => {
      try {
        // Get lab data from state if available
        if (location.state && location.state.lab) {
          const labData = location.state.lab;
          setLab(labData);
          
          // Check if lab is released from Firestore
          // Query all instructors' lab statuses to find if this lab is released
          const instructorsRef = collection(db, 'instructors');
          const queryResult = await getDocs(instructorsRef);
          
          let labIsAvailable = true;
          
          for (const instructorDoc of queryResult.docs) {
            try {
              const statusCollectionRef = collection(db, 'instructors', instructorDoc.id, 'labStatuses');
              const statusDocs = await getDocs(statusCollectionRef);
              
              for (const statusDoc of statusDocs.docs) {
                const statuses = statusDoc.data();
                const labStatus = statuses[`lab_${labData.id}`];
                
                if (labStatus === 'closed') {
                  labIsAvailable = false;
                  break;
                }
              }
              
              if (!labIsAvailable) break;
            } catch (error) {
              console.log('Could not check status for instructor:', instructorDoc.id);
            }
          }
          
          setIsLabAvailable(labIsAvailable);
          console.log('Lab availability:', labIsAvailable);
        }
      } catch (error) {
        console.error('Error loading lab data:', error);
      } finally {
        setLoading(false);
      }
    };
    
    loadLabData();
  }, [location]);

  if (!lab || loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ fontSize: '1.1rem', color: '#666' }}>Loading lab...</p>
      </div>
    );
  }

  // Show locked message if lab is not available
  if (!isLabAvailable) {
    return (
      <div style={{ minHeight: '100vh', background: '#ffffff', padding: '2rem 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', marginBottom: '2rem' }}>
            <button
              onClick={() => navigate(-1)}
              style={{
                width: '40px',
                height: '40px',
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '6px',
                background: '#1a1a1a',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 300ms ease',
              }}
              onMouseOver={(e) => {
                e.target.style.background = '#2d2d2d';
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseOut={(e) => {
                e.target.style.background = '#1a1a1a';
                e.target.style.transform = 'scale(1)';
              }}
            >
              <i className="fas fa-arrow-left"></i>
            </button>
            <div>
              <h1 style={{ fontSize: '2.5rem', margin: '0 0 0.5rem 0', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-1px' }}>
                {lab.title}
              </h1>
              <p style={{ color: '#666', margin: 0, fontSize: '1rem' }}>
                Week {lab.week} • {lab.group} Group
              </p>
            </div>
          </div>

          {/* Locked Message */}
          <div style={{
            background: '#ffebee',
            border: '2px solid #f44336',
            borderRadius: '8px',
            padding: '3rem 2rem',
            textAlign: 'center',
            minHeight: '400px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔒</div>
            <h2 style={{ fontSize: '2rem', fontWeight: 700, color: '#c62828', margin: '0 0 1rem 0' }}>
              Lab Not Available
            </h2>
            <p style={{ color: '#b71c1c', fontSize: '1.1rem', margin: '0 0 2rem 0', maxWidth: '500px' }}>
              This lab is currently closed and not available for submission. Please check back later or contact your instructor.
            </p>
            <button
              onClick={() => navigate(-1)}
              style={{
                background: '#1a1a1a',
                color: 'white',
                border: 'none',
                padding: '0.75rem 2rem',
                borderRadius: '6px',
                fontWeight: 600,
                cursor: 'pointer',
                fontSize: '1rem',
                transition: 'all 300ms ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = '#2d2d2d';
              }}
              onMouseOut={(e) => {
                e.target.style.background = '#1a1a1a';
              }}
            >
              Back to Labs
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#ffffff', padding: '2rem 0' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', marginBottom: '2rem' }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              width: '40px',
              height: '40px',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '6px',
              background: '#1a1a1a',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 300ms ease',
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#2d2d2d';
              e.target.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#1a1a1a';
              e.target.style.transform = 'scale(1)';
            }}
          >
            <i className="fas fa-arrow-left"></i>
          </button>
          <div>
            <h1 style={{ fontSize: '2.5rem', margin: '0 0 0.5rem 0', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-1px' }}>
              {lab.title}
            </h1>
            <p style={{ color: '#666', margin: 0, fontSize: '1rem' }}>
              Week {lab.week} • {lab.group} Group
            </p>
          </div>
        </div>

        {/* Form Container */}
        <div style={{
          background: '#ffffff',
          border: '1px solid #e8e8e8',
          borderRadius: '8px',
          padding: '2rem',
          minHeight: '600px'
        }}>
          <iframe
            src={lab.pdfUrl}
            style={{
              width: '100%',
              height: '800px',
              border: 'none',
              borderRadius: '6px'
            }}
            title={lab.title}
            allow="geolocation *; microphone *; camera *"
          ></iframe>
        </div>

        {/* Info */}
        <div style={{
          marginTop: '2rem',
          padding: '1.5rem',
          background: '#f9f9f9',
          borderRadius: '8px',
          border: '1px solid #e8e8e8'
        }}>
          <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: '0 0 0.75rem 0', color: '#1a1a1a' }}>
            Lab Information
          </h3>
          <p style={{ margin: '0.5rem 0', color: '#666', fontSize: '0.95rem' }}>
            <strong>Title:</strong> {lab.title}
          </p>
          <p style={{ margin: '0.5rem 0', color: '#666', fontSize: '0.95rem' }}>
            <strong>Week:</strong> Week {lab.week}
          </p>
          <p style={{ margin: '0.5rem 0', color: '#666', fontSize: '0.95rem' }}>
            <strong>Group:</strong> {lab.group}
          </p>
          <p style={{ margin: '0.5rem 0', color: '#666', fontSize: '0.95rem' }}>
            <strong>Status:</strong> <span style={{ color: lab.status === 'released' ? '#2e7d32' : '#c62828', fontWeight: 600 }}>
              {lab.status === 'released' ? 'Available' : 'Locked'}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TakeLab;
